import { render, staticRenderFns } from "./CdrDuration.vue?vue&type=template&id=18ae88b8&scoped=true&"
import script from "./CdrDuration.vue?vue&type=script&lang=ts&"
export * from "./CdrDuration.vue?vue&type=script&lang=ts&"
import style0 from "./CdrDuration.vue?vue&type=style&index=0&id=18ae88b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae88b8",
  null
  
)

export default component.exports